<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="innerValue"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        prepend-inner-icon="date_range"
        :value="dateFormatted"
        :label="label"
        readonly
        :solo="solo"        
        v-on="!readonly ? on : null"
        :hide-details="hideDetails"
        :dense="dense"
        :error-messages="errorMessages"
        :clearable="!readonly"
        :disabled="disabled"
        @click:clear="clearToday()"        
        v-bind="attrs"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="innerValue"
      no-title
      scrollable
      :readonly="readonly"
      :min="min"
      :max="max"
    >
      <div>
        <v-btn text color="info" @click="setToday()">
          Today
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-show="showOkCancelButton"
          text
          @click="menu = false"
        >
          Cancel
        </v-btn>
        <v-btn
          v-show="showOkCancelButton"
          text
          color="info"
          @click="$refs.menu.save(innerValue)"
        >
          OK
        </v-btn>
      </div>
    </v-date-picker>
  </v-menu>
</template>

<script>

import formatterMixin from "src/mixins/formatterMixin";

export default {
  mixins: [formatterMixin],
  props: {
    min: String,
    max: String,
    solo: Boolean,
    hideDetails: Boolean,
    dense: Boolean,
    value: [String, Date, Object],
    label: String,
    errorMessages: [Array],
    blur: [Function, Object],
    showOkCancelButton: Boolean,
    disabled: Boolean,
    readonly: Boolean,
  },

  data() {
    return {
      menu: false,
      date: this.value,
      innerValue: this.value ? this.value : '',
    };
  },

  computed: {
    dateFormatted() {
      return this.formatDate(this.innerValue);
    },
  },

  methods: {
    clearToday() {
      this.innerValue = null;
      this.$emit("onClear");
    },
    setToday() {
      this.innerValue = this.formatDate(new Date())
    }
  },

  created() {
    this.$on("blur", this.blur);
  },

  watch: {
    value(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.innerValue = newValue ? newValue : "";
      }
    },

    innerValue(value) {
      this.$emit("input", value);
      // if button ok and cancel not shown, then close after data picked
      if (!this.showOkCancelButton) {
        this.$refs.menu.save(value);
      }
    },
  },
};
</script>